import { isRSAA, CALL_API } from 'redux-api-middleware'

export default function(store) {
  return function(next) {
    return function(action) {
      // Check if this action is a redux-api-middleware action.
      if (!isRSAA(action)) {
        return next(action);
      }

      // console.log('authMiddleware: ' + action[CALL_API].endpoint);

      const callApi = action[CALL_API];

      callApi.credentials = 'include';

      let finalAction = { ...action };

      return next(finalAction)
        .then(
          attemptRefresh({
            action,
            next,
            store
          })
        );
    }
  }
}

const attemptRefresh = function(settings) {
  const {
    action,
    next,
    store
  } = settings;

  return function(response) {
    if (
      response.error &&
      response.payload.status === 401
    ) {
      // This will ensure that the fail action goes all the way to the bottom
      next(response);

      let url = window.location.href;
      url = new URL(url);
      let participantId = url.searchParams.get('participantId');

      let redirectUri = window.location.href.split('?')[0];

      // console.log(`${process.env.API_URI}/login?redirect_uri=${encodeURIComponent(redirectUri)}`);

      // window.location.href = `${process.env.API_URI}/login?redirect_uri=${encodeURIComponent(redirectUri)}&participant_id=${encodeURIComponent(participantId)}`;

      // for now redirect to the login page
      window.location.href = process.env.LOGIN_URI;
    }
  };
};
